import axios from '../../plugins/axios'
var jwt = require("jsonwebtoken");

export default {
    namespaced : true,
    state : {
        username: "",
        refresh: "",
        access : "",
        authenticated: false,
        loginMessage: "", 
        runstatistics: null, 
        expiryChecker : null,
        m_url : null

    },    
    actions : {

        login: ({ state, commit, dispatch, getters }, payload) => {
            axios
            .post("/api/token/", {
                username: payload.username,
                password: payload.password
            })
            .then(response => {
                state.authenticated = true
                state.refresh       = response.data.refresh
                state.access        = response.data.access

                axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.access;

                state.loginMessage = "";

                dispatch("user/getUser",null,{root:true} ).then(() => {
                    // state.runstatistics = setInterval(() => {
                    //     dispatch("checkStatistics", null, {root:true});
                    // }, 310000);
                });

                state.expiryChecker = setInterval(() => {
                    let v = jwt.decode(state.access).exp * 1000;

                    if (Date.now() >= v-5) {
                        // console.log("Token is about to expire, requesting a new token");

                        let r = jwt.decode(state.refresh).exp * 1000;

                        if (Date.now() >= r) {
                            // console.log("Refresh token is expired, logging out");
                            state.loginMessage = "Uw sessie is verlopen, opnieuw inloggen verplicht";
                            dispatch("logout",null,{root:true});
                            return;
                        } else {
                            axios
                            .post("/api/token/refresh/", {
                                refresh: state.refresh
                            })
                            .then(response => {
                                // storing the new access token in the axios header.
                                axios.defaults.headers.common["Authorization"] =
                                "Bearer " + response.data.access;
                                state.access = response.data.access
                            })
                            .catch(() => {
                                state.loginMessage = "Opnieuw inloggen verplicht";
                                dispatch("logout",null,{root:true});
                            });
                        }
                    }
                }, 31000)

                dispatch("getTypes", null, {root:true});
                dispatch("getObjects", null, {root:true});
            })
            .catch(() => {
                state.loginMessage = "Ongeldige inloggegevens";
            });
        },
        getAuthentication : ({state, commit, rootState}) => {
            axios.get("api/user/m-auth").then(response => {
               
                var url = "https://quootz.com/doklegal/default?user=" +
                    rootState.user.organisation.reference +
                    "&template=" +
                    rootState.contract.template.title +
                    "&name=" +
                    rootState.contract.reference +
                    "&authkey=" +
                    response.data.key +
                    "&showmenubar=false&showtoolbar=false&language=nl&version=HIGHEST_RELEASED_VERSION"
                
                commit("app/setMerkatoUrl", url, {root:true})

            }).catch(() => {
                commit("app/merkatoError", null, {root:true})
            })

        }
    }
}